import PillButton from "client/common/components/buttons/PillButton";
import { useFeatures } from "client/clinics/hooks";
import { urls } from "client/routes";

const DealsLink = () => {
  const features = useFeatures();

  if (!features.DEALS) {
    return null;
  }

  return (
    <PillButton size="s" variant="secondary" dest={urls.products.deals()}>
      View deals
    </PillButton>
  );
};

export default DealsLink;
